/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Configuration for detecting when fields are changed.
 * @export
 * @interface FieldChangedEvent
 */
export interface FieldChangedEvent {
    /**
     * If always, the integration will monitor for field changes by default.
     * @type {string}
     * @memberof FieldChangedEvent
     */
    enabled: FieldChangedEventEnabledEnum;
}


/**
 * @export
 */
export const FieldChangedEventEnabledEnum = {
    Always: 'always'
} as const;
export type FieldChangedEventEnabledEnum = typeof FieldChangedEventEnabledEnum[keyof typeof FieldChangedEventEnabledEnum];


/**
 * Check if a given object implements the FieldChangedEvent interface.
 */
export function instanceOfFieldChangedEvent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "enabled" in value;

    return isInstance;
}

export function FieldChangedEventFromJSON(json: any): FieldChangedEvent {
    return FieldChangedEventFromJSONTyped(json, false);
}

export function FieldChangedEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): FieldChangedEvent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'enabled': json['enabled'],
    };
}

export function FieldChangedEventToJSON(value?: FieldChangedEvent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'enabled': value.enabled,
    };
}

